import { Component, OnInit } from '@angular/core';
import { NbDialogRef, NbToastrService } from '@nebular/theme';
import { RestService } from '../rest.service';

@Component({
  selector: 'ngx-finance-calculator',
  templateUrl: './finance-calculator.component.html',
  styleUrls: ['./finance-calculator.component.scss']
})
export class FinanceCalculatorComponent implements OnInit {

  financeObject: any = {};
  financeFactorList: any = [];
  constructor(public ref: NbDialogRef<FinanceCalculatorComponent>, private restService: RestService, private toastrService: NbToastrService) { }
  options = {
    align: 'left',
    prefix: '$',
    thousands: ',',
    decimal: '.',
    inputMode: 1, nullable: false,
  };
  options1 = {
    align: 'left',
    prefix:'',
    allowNegative: 'false',
    thousands: ',',
    decimal: '.',
    inputMode: 1, nullable: false,
    max:100,
    min:0,
  };
  ngOnInit() {
    this.financeObject.totalPremium = 1000;
    this.financeObject.downPaymentPercentage = 20;
    this.financeObject.yrPolicy = 'No';
    this.financeObject.payFactor = '9';
    this.financeObject.downPaymentInputType = '%';
  }

  // getFinanceFactor() {
  //   this.restService.model('GetMasterFindAll/' + 'FinanceFactor').subscribe((response) => {
  //     this.financeFactorList = response.reverse();
  //   });
  // }
  financeResultLabel: any = [];
  financeResultObject: any = {};
  financeLimitExceed: boolean = false;
  calculate(financeObject) {
    // tslint:disable-next-line: no-console
    
    this.errorObj = {};
    if (this.validateTotalPremiumAndDownPayment(financeObject, this.errorObj)) {
      this.restService.postModel(financeObject, 'GetFinanceCalculation').subscribe((res) => {
        if (res.ResponseStatus) {
          // tslint:disable-next-line: no-console
          console.log(JSON.parse(res.ResponseData));
          this.financeResultObject = JSON.parse(res.ResponseData);
          this.financeFactorList = JSON.parse(this.financeResultObject.financeFactorList);
          delete this.financeResultObject.financeFactorList;
          this.financeResultLabel = Object.keys(this.financeResultObject);
          this.financeLimitExceed = false;
        } else {
          this.financeLimitExceed = true;
          this.financeResultObject = {};
          this.financeFactorList = [];
          this.financeResultLabel = [];

        }
      });
    } else {
      this.showToast('Form Invalid', 'danger');
    }

  }

  errorObj: any = {};
  validateTotalPremiumAndDownPayment(financeObject, errorObj) {
    this.validateString(financeObject.totalPremium, 'totalPremium', errorObj);
    this.validateString(financeObject.downPaymentPercentage, 'downPaymentPercentage', errorObj);
    
    return !(JSON.stringify(errorObj).search('true') > -1);
  }

  validateString(str, key, errorObj) {
    errorObj[key] = false;
    if (!(str !== undefined && str != null && !(/^\s*$/.test(str)) && parseFloat(str) > 0)) {
      errorObj[key] = true;
    }
    return errorObj;
  }

  checkObjectKeys(financeResultLabel) {
    return Object.keys(financeResultLabel).length > 0;
  }

  insertSpaces(string) {
    string = string.replace(/([a-z])([A-Z])/g, '$1 $2');
    string = string.replace(/([A-Z])([A-Z][a-z])/g, '$1 $2');
    return string;
  }


  notCurrency(str) {
    return 'payFactor,APR'.search(str) > -1;
  }

  amtReceivedRegex(str) {
    return 'Up to $' + str.substring(str.lastIndexOf('<=') + 2);
  }


  showToast(content, status) {
    this.toastrService.show(content, `Status`, { status });
  }
}
